import { FilesIcon } from '@phosphor-icons/react';

import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const Documents = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return <FilesIcon {...rest} size={Sizes[size]} color={fill} />;
};

Documents.displayName = 'Documents';
